// A balança vale aqui? Junta as três condições: o produto está marcado
// "Pesar na balança", este computador tem balança configurada e a loja liga a
// balança neste módulo (Preferências). `modulo` vazio = nunca (o cardápio do
// cliente usa o mesmo quadro de peso e não tem balança).
import { useEffect, useState } from "react";

import { aoMudarConfig, balancaLigadaAqui, lerConfig } from "./config";
import { usePrefsBalanca } from "./preferencias";

export function useConfigBalanca() {
  const [cfg, setCfg] = useState(lerConfig);
  useEffect(() => aoMudarConfig(setCfg), []);
  return cfg;
}

export function useBalanca({ modulo, produto }) {
  const cfg = useConfigBalanca();
  const prefs = usePrefsBalanca();
  const ativa = !!(
    modulo && produto?.usa_balanca && produto?.sale_unit === "kg" &&
    balancaLigadaAqui(cfg) && prefs && (prefs.modulos || []).includes(modulo)
  );
  return {
    ativa,
    modo: prefs?.modo || "manual",
    minimoKg: (Number(prefs?.peso_minimo_g) || 0) / 1000,
    taraGramas: Number(produto?.tara_gramas) || 0,
  };
}
